import getters from '@/store/getters'
import common from '@/store/modules/common'
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    common,
  },
  getters
})
export default store
